module.exports = __webpack_public_path__ + "img/v1.2f701735.png";